/* =========================================================
   MENTALITÉ — compte à rebours (section mentalite-hero)
   <mtl-countdown data-target="2026-11-13T18:00:00+01:00">
   ========================================================= */
if (!customElements.get('mtl-countdown')) {
  customElements.define(
    'mtl-countdown',
    class MtlCountdown extends HTMLElement {
      connectedCallback() {
        this.target = Date.parse(this.dataset.target);
        if (Number.isNaN(this.target)) return;
        this.units = {};
        this.querySelectorAll('[data-unit]').forEach((el) => (this.units[el.dataset.unit] = el));
        this.done = this.querySelector('.mtl-countdown__done');
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const diff = this.target - Date.now();
        if (diff <= 0) {
          clearInterval(this.timer);
          this.classList.add('is-done');
          this.removeAttribute('role');
          if (this.done) this.done.hidden = false;
          return;
        }
        const s = Math.floor(diff / 1000);
        const values = {
          d: Math.floor(s / 86400),
          h: Math.floor((s % 86400) / 3600),
          m: Math.floor((s % 3600) / 60),
          s: s % 60,
        };
        Object.keys(values).forEach((k) => {
          if (this.units[k]) this.units[k].textContent = String(values[k]).padStart(2, '0');
        });
      }
    }
  );
}

/* =========================================================
   MENTALITÉ — vidéos des cartes produit
   Lecture auto (muette, en boucle) uniquement quand la carte est
   à l'écran, pause sinon. Respecte « réduire les animations ».
   ========================================================= */
(function () {
  if (window.__mtlVideos) return;
  window.__mtlVideos = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && !reduce) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.15 })
    : null;

  function setup(root) {
    (root || document).querySelectorAll('video[data-mtl-video]:not([data-mtl-ready])').forEach(function (v) {
      v.setAttribute('data-mtl-ready', '');
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
      if (io) io.observe(v);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
  else setup();
  // Éditeur de thème : sections rechargées à la volée
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
